import React from 'react'
import MiCompAPI from '../../../util/api';
import {
 Form,
 Input,
 Checkbox,
 Icon,
 Radio,
 Select,
 Row,
 Col,
 Button,
 Divider
} from 'antd';
import InputMask from "react-input-mask";

const { Option } = Select;
class EAD extends React.Component {
 constructor(props) {
  super(props)
  this.state = {
   isloding: false, States: [], value: 1
  };
  this.api = new MiCompAPI(this.props.userPermandMasters);

 }
 getClientMasters() {
  this.api.invoke(
   "GetMasters",
   "post",
   (data, success) => {
    if (success) {
     this.setState({
      States: data.states,



     });

    }
   },
   ["STATE"]
  );
 }
 componentDidMount = () => {
  this.getClientMasters();

 }
 onChangeradio =(e) =>{
  
  this.setState({value:e.target.value});
 }
 onChangeCheckbox = () =>{
 }
 Cancel() {
  sessionStorage.clear();

  window.location.pathname = "";
}
Back() {
 sessionStorage.clear();
this.props.history.push('/mynipr');
}

 render() {
  const { getFieldDecorator } = this.props.form;
  return (
   <div className="mi_main_div">
<Row style={{ content: 'center' }}>
       <Col md={12} sm={24}>
     <div className='mi_main' style={{ boxShadow: " 0px 0px 0px 2px #d9d9d9" }}>

      <Form layout="vertical" hideRequiredMark>
      <Row style={{ content: 'center' }}>
       <Col  sm={24}>
        <p style={{fontWeight:"700",fontSize:"18px"}}>Billing Details</p>
        <Row>
         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset className="mi_input_pop">
            <legend className="legend-font">First Name</legend>
            {getFieldDecorator('first_Name', {
             rules: [{ required: true, message: 'Please enter First Name' }, {
              pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
              message: "It allows only Alphabets"
             }],
            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter First Name" />)}
           </fieldset>
          </Form.Item>
         </Col>

         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset className="mi_input_pop">
            <legend className="legend-font">Last Name</legend>
            {getFieldDecorator('last_Name', {
             rules: [{ required: true, message: 'Please enter Last Name' }, {
              pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
              message: "It allows only Alphabets"
             }],
            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Last Name" />)}
           </fieldset>
          </Form.Item>
         </Col></Row>
        <Row>
         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset className="mi_input_pop">
            <legend className="legend-font">Address Line 1</legend>
            {getFieldDecorator('address_line_1', {
             rules: [{ required: true, message: 'Please enter Address Line 1' }, {
              pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
              message: "It allows only Alphabets"
             }],
            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Address Line 1" />)}
           </fieldset>
          </Form.Item></Col>

         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset className="mi_input_pop">
            <legend className="legend-font">Address Line 2</legend>
            {getFieldDecorator('address_line_2', {
             rules: [{ required: false, message: 'Please enter Address Line 2' }, {
              pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
              message: "It allows only Alphabets"
             }],
            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Address Line 2" />)}
           </fieldset>
          </Form.Item></Col>
        </Row>
        <Row>
         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset className="mi_input_pop">
            <legend className="legend-font">Address Line 3</legend>
            {getFieldDecorator('address_line_3', {
             rules: [{ required: false, message: 'Please enter Address Line 3' }, {
              pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,#,-]+$/,
              message: "It allows only Alphabets"
             }],
            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Address Line 3" />)}
           </fieldset>
          </Form.Item></Col>

         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset className="mi_input_pop">
            <legend className="legend-font">City</legend>
            {getFieldDecorator('city', {
             rules: [{ required: true, message: 'Please enter City' }, {
              pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
              message: "It allows only Alphabets"
             }],
            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="City" />)}
           </fieldset>
          </Form.Item></Col>
        </Row>
        <Row>
         <Row>
          <Col md={12} sm={24}>
          <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">State or Province </legend>
                    {getFieldDecorator('state', {
                      rules: [{ required: true, message: 'Please enter stateor Province ' },],
                    })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                      optionFilterProp="children"
                      showSearch={true}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={this.onChange}
                      placeholder="Please Select State or Province ">
                      {this.state.States.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                    </Select>)}
                  </fieldset>
                </Form.Item></Col>

          <Col md={12} sm={24}>
           <Form.Item>
            <fieldset className="mi_input_pop">
             <legend className="legend-font">Country</legend>
             {getFieldDecorator('country', {
              rules: [{ required: true, message: 'Please enter Country' },],
             })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
              optionFilterProp="children"
              showSearch={true}
              filterOption={(input, option) =>
               option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              }

              placeholder="Please Select Country ">
              <Option value="albania">Albania</Option>
              <Option value="afganisthan" key={0} >Afganisthan</Option>
              <Option value="belgium" key={1} > Belgium</Option>
              <Option value="india" key={2}> India</Option>
              <Option value="iran" key={3} > Iran</Option>
              <Option value="irak" key={4} > Irak</Option>
             </Select>)} </fieldset>
           </Form.Item></Col>

         </Row>
        </Row>
        <Row>
         <Col md={12} sm={24}>
          <Form.Item>
           <fieldset  className="mi_input_pop">
            <legend className="legend-font">ZIP Code</legend>
            {getFieldDecorator('zipb', {
             rules: [{ required: true, message: 'Please enter a valid zip code' }
              , {
              pattern: /^\d{5}(?:[-\s]\d{4})?$/,
              message: 'Zip code is invalid'
             }],
            })(<InputMask mask="99999" autoComplete={"nope"}  className="ant-input mi_input" type="text" placeholder="Enter ZIP Code *" />)}
           </fieldset>

          </Form.Item></Col>

         <Col md={12} sm={24}>
          <Form.Item >
           <fieldset className="mi_input_pop" >
            <legend className="legend-font">Phone Number</legend>
            {getFieldDecorator('phoneNo', {
             rules: [{ required: true, message: 'Please enter   phone number.' },
             {
              pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
              message: "Invalid Phone Number",
             },],
            })(
             <InputMask mask="+1 (999) 999-9999" autoComplete={"nope"}  type="text" className="ant-input mi_input" placeholder="Enter Phone Number *" />
            )
            }
           </fieldset>
          </Form.Item></Col>
        </Row>

       </Col>
      </Row>
      <Row><Col><Divider>Your Total is: $5.60</Divider></Col></Row></Form>
      </div >
      </Col>
      <Col md={12} sm={24}>
      <div className='mi_main' style={{ boxShadow: " 0px 0px 0px 2px #d9d9d9" }}>
       <Row>
        <Col sm={24}>
         <p style={{fontWeight:"700",fontSize:"18px"}}>Choose Payment Type</p>
         <p style={{fontWeight:"700",fontSize:"16px"}}>How would you like to pay?</p>
         <Radio.Group className="mi_input_pop" defaultValue={1} onChange={this.onChangeradio}>


          <Radio value={1} >Credit Card</Radio>
          <Radio   value={2} >Electronic Check   </Radio>

         </Radio.Group>
        </Col>
        {this.state.value === 1 ?
        <>
        <Row>
         <Col  sm={24}>


          <>
           <Form layout="vertical" hideRequiredMark style={{marginTop:"12px",fontWeight:"600"}}>
            <p
            style={{ fontSize: "20px", color: "rgba(48, 43, 87, 1)" }}
           >
            Credit Card
           </p>
            <Row>
             <Col md={24} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> Card Number</legend>
                {getFieldDecorator('cardnumber', {
                 rules: [{ required: true, message: 'Please enter Card Number.' },
                 ],
                })(
                 <InputMask mask="9999 9999 9999 9999" autoComplete={"nope"}  type="text" className="ant-input mi_input"
                  placeholder="Enter Card Number" />
                )}
               </fieldset>
              </Form.Item></Col>


             <Col md={12} style={{ padding: "0px 3px 0px 0px" }}>

              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> Expiry Date</legend>
                {getFieldDecorator('expirydate', {
                 rules: [{ required: true, message: 'Please enter Expiry Date.' },
                 ],
                })(<InputMask mask="99/99" className="ant-input mi_input" type="text"  placeholder="MM/YY"></InputMask>)}
               </fieldset>
              </Form.Item>
             </Col>
             <Col md={12} style={{ padding: "0px 0px 0px 3px" }}>

              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> CVV</legend>
                {getFieldDecorator('cvv', {
                 rules: [{ required: true, message: 'Please enter  CVV.' },
                 ],
                })(<InputMask mask="999" className="ant-input mi_input" type="text"  placeholder="CVV"></InputMask>)}
               </fieldset>
              </Form.Item>
             </Col>
             <Row>
              <Col md={24}>
               <p style={{textAlign:"center",marginTop:"19px"}}>User understands all fees are non re-fundable</p>
               <p style={{textAlign:"center"}}><Checkbox onChange={this.onChangeCheckbox} > I agree</Checkbox></p>
              </Col>
             </Row>
             <Row style={{ marginTop: "20px", paddingTop: "10px" }}>
             <Col md={8}>
             <Button style={{textAlign:"center" ,width:"fit-content"}} htmlType='submit' className=" ant-btn-primary">Submit $5.60 Payment</Button>
             </Col>
              <Col md={8}>
               <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right",marginRight: "15px" }}
               onClick={() => this.Back()}>Back</Button>
              </Col>
              <Col md={8}>
              <Button className="submit-button" onClick={() => this.Cancel()}>
                        Cancel
                    </Button>

              </Col>

             </Row>

            </Row></Form></>


         </Col>
         </Row></>:
         <Form layout="vertical" hideRequiredMark style={{marginTop:"12px",fontWeight:"600"}}>
          <p
            style={{ fontSize: "20px", color: "rgba(48, 43, 87, 1)" ,marginTop:"10px"}}
           >Electronic Check Details</p>
            <Row>
             <Col md={12} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font">  Name as it appears on check</legend>
                {getFieldDecorator('check_name', {
                 rules: [{ required: true, message: 'Please enter Name.' },
                 ],
                })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Name" />)}
               </fieldset>
              </Form.Item>
              </Col>
              <Col md={12} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font">  Check Number</legend>
                {getFieldDecorator('check_number', {
                 rules: [{ required: true, message: 'Please enter Check Number.' },
                 ],
                })(<Input maxLength={20} autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Check Number" />)}
               </fieldset>
              </Form.Item>
              </Col>
              </Row>
              <Row>
             <Col md={12} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> Memo</legend>
                {getFieldDecorator('memo', {
                 rules: [{ required: true, message: 'Please Memo.' },
                 ],
                })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Memo" />)}
               </fieldset>
              </Form.Item>
              </Col>
              <Col md={12} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font">  Type your full name here</legend>
                {getFieldDecorator('full_name', {
                 rules: [{ required: true, message: 'Please enter Type your full name here.' },
                 ],

                })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Check Number" />)}
               </fieldset>
              </Form.Item>
              </Col>
              </Row>


              <Row>
             <Col md={12} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> Bank Routing Number</legend>
                {getFieldDecorator('brouting_number', {
                 rules: [{ required: true, message: 'Please Bank Routing Code.' },
                 ],
                })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Bank Routing Code" />)}
               </fieldset>
              </Form.Item>
              </Col>
              <Col md={12} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> Bank Account Number</legend>
                {getFieldDecorator('bAccount_number', {
                 rules: [{ required: true, message: 'Please enter Type your full name here.' },
                 ],

                })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Bank Account Number" />)}
               </fieldset>
              </Form.Item>
              </Col>
              </Row>
              <Row><Col md={24} sm={24}>
              <Form.Item>
               <fieldset className="mi_input_pop">
                <legend className="legend-font"> Pay to the order of National Insurance Producer Registry</legend>
                {getFieldDecorator('pay_nipr', {
                 rules: [{ required: true, message: 'Please enter Type your full name here.' },
                 ],

                })(<Input disabled autoComplete={"nope"}  className="mi_input" type="text" placeholder="$5.60" />)}
               </fieldset>
              </Form.Item>
              </Col></Row>
<Row>
  <Col md={12}>
  <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right",marginRight: "15px" }}
               onClick={() => this.Back()}>Back</Button>
              </Col>
              <Col md={8}>
              <Button className="submit-button" >
                        Next
                    </Button>
  </Col>
</Row>

           </Form>}

       </Row></div>
</Col>
      </Row>

   </div>

  )
 }
}


const NiprPayment = Form.create()(EAD);

export default NiprPayment;